
namespace appn.views.taskTemplates._connectors {

    class InitArgs {
        fireEventStatusChanged: string = appn.emptyString;
        fireEventOverdue: string = appn.emptyString;
    }

    let _initArgs: InitArgs;
    let _restHeaderTemplate = appn.emptyString;

    export function init(args: InitArgs): void {
        _initArgs = args;

        // Grab the rest header template and remove it from the document.
        const restHeaderTemplate = $('#RESTHeaderRowTemplate');
        _restHeaderTemplate = restHeaderTemplate.html();
        restHeaderTemplate.remove();

        appn.ui.formExpansionHelper.init('.connector');

        addEvents();

        // enable focus after we've loaded everything
        (window as any).focusEnabled = true;

        registerFormExpansionHelper();

        select.init({ selector: '.box.connector select.httpVerb,.box.connector select.formatType', omitWidth: true });
    }

    function addEvents() {
        $('.fire-event').on('change', function() {
            const thisVal = $(this);
            const connector = thisVal.closest('.connector');

            const fireEventStatus = connector.find('.fire-event-status, .fire-event-status-label');
            if (thisVal.val() === _initArgs.fireEventStatusChanged) {
                fireEventStatus.removeClass('d-none');

                select.init({
                    selector: '.fire-event-status'
                });
            } else {
                fireEventStatus.addClass('d-none');

                select.init({
                    selector: '.fire-event-status'
                });
            }

            const fireEventByDays = connector.find('.fire-event-by-days, .fire-event-by-days-label');
            if (thisVal.val() === _initArgs.fireEventOverdue)
                fireEventByDays.removeClass('d-none');
            else
                fireEventByDays.addClass('d-none');

            select.init({ selector: '.box.connector .fire-event,.box.connector .fire-event-status' });
        }).change();

        $('.connector').on('click', '.buildIcon', function() {
            const thisVal = $(this);
            const formulaBox = thisVal.closest('.input-group').find('.form-control');
            appn.ui.formulabuilder.currentFormula = formulaBox.val() as string;
            appn.ui.formulabuilder.currentMode = thisVal.data('type');
            appn.ui.formulabuilder.formulaUpdated = function(formula: string) {
                formulaBox.val(formula);
            };
            
            appn.ui.formulabuilder.showDialog();
        });

        $('.btn-clone-connector').click(function() {
            const connectorId = $(this).closest('.connector').prop('id');

            const form = $('form#appnForm');
            form.append(`<input type="hidden" name="submitType" value="clone${connectorId}" />`);
            form.submit();
        });

        $('.btnTryAddConnector').off().on('click', function(event) {
            event.preventDefault();
            $('#addConnector').click();
        });
    }

    function registerFormExpansionHelper() {
        appn.ui.formExpansionHelper.registerHandler('restHeaders', function(common: any, show: any, hide: any) {
            return {
                open: function(key: any, link: any, expansion: any) {
                    common.open(key, link, expansion);
                    if (expansion.find('.rest-header').length === 0)
                        expansion.find('.add-header a').click();
                },
                insert: function(key: any, link: any, expansion: any) {
                    const headers = expansion.find('.headersRow');
                    const connectorIdx = expansion.closest('.connector').data('connector-index');
                    const newRowIdx = (new Date()).getTime();
                    const templateHtml = _restHeaderTemplate
                        .replace(/ConnectorsREST\[0\]/g, `ConnectorsREST[${connectorIdx}]`)
                        .replace(/ConnectorsREST_0__/g, `ConnectorsREST_'${connectorIdx}'__`)
                        .replace(/Headers\[0\]/g, `Headers[${newRowIdx}]`)
                        .replace(/Headers_0__/g, `Headers_${newRowIdx}__`);

                    const newRow = $(templateHtml);
                    newRow.find('input').val('');
                    newRow.find('.rowIndexer').val(newRowIdx);
                    newRow.insertBefore(link.parent());
                },
                close: function(key: any, link: any, expansion: any) {
                    link.closest('.rest-header').remove();
                    const headerRows = expansion.find('.rest-header');
                    if (headerRows.length === 0)
                        common.close(key, link, expansion);
                }
            };
        });
    }
}
